











































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import NavBar from '@/components/layout/NavBar.vue';
import { Card, Form, FormItem, Button, Input } from 'element-ui';
import { userService } from '@/services/UserService';
import { FetchResult } from 'apollo-link';
import { fuelSurcharge } from '@/types/graphql/schemaTypes';

@Component({
  components: {
    NavBar,
    'el-card': Card,
    'el-form': Form,
    'el-form-item': FormItem,
    'el-input': Input,
    'el-button': Button
  }
})
export default class Settings extends Vue {
  public inputForm = {
    fclMargin: '',
    lclMargin: '',
    anaMargin: '',
    fuelSurcharge: '',
    drayageMarginJapan: '',
    drayageMarginWorld: '',
    truckingMarginJapan: '',
    truckingMarginWorld: '',
    taxRate: '',
    smallTruckingMarginJapan: '',
    usdJpyExchangeRate: ''
  };

  public editing = false;

  created() {
    this.fetchSettings();
  }

  private cancel() {
    this.editing = false;
    this.fetchSettings();
  }

  private fetchSettings() {
    userService.fetchOrganization().then((res: any) => {
      const settings = res.data!.currentOperator.organization;
      this.inputForm.fclMargin = (settings.fclMargin * 100).toFixed(2);
      this.inputForm.lclMargin = (settings.lclMargin * 100).toFixed(2);
      this.inputForm.anaMargin = (settings.anaMargin * 100).toFixed(2);
      this.inputForm.fuelSurcharge = (settings.fuelSurcharge * 100).toFixed(2);
      this.inputForm.drayageMarginJapan = (settings.drayageMarginJapan * 100).toFixed(2);
      this.inputForm.drayageMarginWorld = (settings.drayageMarginWorld * 100).toFixed(2);
      this.inputForm.truckingMarginJapan = (settings.truckingMarginJapan * 100).toFixed(2);
      this.inputForm.truckingMarginWorld = (settings.truckingMarginWorld * 100).toFixed(2);
      this.inputForm.taxRate = (settings.taxRate * 100).toFixed(2);
      this.inputForm.usdJpyExchangeRate = settings.usdJpyExchangeRate.toFixed(2);
      this.inputForm.smallTruckingMarginJapan =
        (settings.smallTruckingMarginJapan * 100).toFixed(2);
    });
  }

  private onSubmit() {
    this.$store.dispatch(
      'User/updateOrganization',
      {
        fclMargin: parseFloat(this.inputForm.fclMargin) / 100,
        lclMargin: parseFloat(this.inputForm.lclMargin) / 100,
        anaMargin: parseFloat(this.inputForm.anaMargin) / 100,
        fuelSurcharge: parseFloat(this.inputForm.fuelSurcharge) / 100,
        drayageMarginJapan: parseFloat(this.inputForm.drayageMarginJapan) / 100,
        drayageMarginWorld: parseFloat(this.inputForm.drayageMarginWorld) / 100,
        truckingMarginJapan: parseFloat(this.inputForm.truckingMarginJapan) / 100,
        truckingMarginWorld: parseFloat(this.inputForm.truckingMarginWorld) / 100,
        taxRate: parseFloat(this.inputForm.taxRate) / 100,
        smallTruckingMarginJapan: parseFloat(this.inputForm.smallTruckingMarginJapan) / 100,
        usdJpyExchangeRate: parseFloat(this.inputForm.usdJpyExchangeRate)
      }
    );
    this.editing = false;
  }
}
